module.exports = __webpack_public_path__ + "img/NCC2010A_R.f9ce0372.png";